import React from 'react';
import {Tooltip, Typography} from 'antd';
import { CellRenderers } from "utils/tableUtils";

const TrimText = props => {
    const text = props.content;
    const textLength = text.length;
    const defaultTitle = "Click on Finding Id to view complete details";
    const trimmedText = CellRenderers.VALUE_OR_NA(text.substring(0,props.length));

    return props.length && textLength > props.length ? (
      <>
        {trimmedText}
        <Tooltip title={text ? text : defaultTitle}>
          <Typography.Link>...more</Typography.Link>
        </Tooltip>
      </>
    ) : (
      <div title={text} className='text-ellipsis'>
        {CellRenderers.VALUE_OR_NA(text)}
      </div>
    );
}
export default TrimText;